import React, { useEffect, useRef, useState } from "react";
import "./Carousel.css";
import DoctorCard from "../../components/DoctorCard";
import leftarrow from "../../asstes/images/leftarrow.png";
import rightarrow from "../../asstes/images/rightarrow.png";

const CarouselView = ({ listData, selectedDoctor, onClick }) => {
  const containerRef = useRef();
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(3);

  const scroll = (direction) => {
    let nextPage = currentPage + direction;

    // Enable looping
    if (nextPage < 0) {
      nextPage = totalPages - 1; // Go to last page
    } else if (nextPage >= totalPages) {
      nextPage = 0; // Go to first page
    }

    if (containerRef.current) {
      const firstCard = containerRef.current.children[0];
      const cardWidth = firstCard?.offsetWidth;
      const marginRight = 16; // keep this consistent
      const pageWidth = itemsPerPage * (cardWidth + marginRight);

      containerRef.current.scrollTo({
        left: nextPage * pageWidth,
        behavior: "smooth",
      });

      setCurrentPage(nextPage);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 600) {
        setItemsPerPage(1);
      } else if (window.innerWidth < 900) {
        setItemsPerPage(2);
      } else {
        setItemsPerPage(3);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const totalPages = Math.ceil(listData.length / itemsPerPage);

  return (
    <div>
      <div className="carousel-wrapper">
        {listData.length > 3 &&
          <button className="arrow-btn" onClick={() => scroll(-1)}>
            <img src={leftarrow} className="doc-nav-left" alt="left" />
          </button>
        }

        <div className="carousel-container" ref={containerRef}>
          {listData.length > 0 && listData.map((item, index) => {
            const isActive = item?.doctorid
              ? selectedDoctor?.doctorid === item?.doctorid
              : selectedDoctor?.userId === item?.userId;

            let metadeta = item?.metadeta && JSON.parse(item?.metadeta);

            return (
              <DoctorCard
                key={item?.doctorid || item?.userId || index}
                doctorName={item?.carenavigatorname || item?.doctorname}
                specialization={item?.specialization || (metadeta?.length > 0 && metadeta[0]?.specialization)}
                avatar={item?.avatar}
                bio={item?.bio || (metadeta?.length > 0 && metadeta[0]?.bio)}
                active={isActive}
                onClick={() => onClick(item)}
              />
            );
          })}
        </div>
        {listData.length > 3 &&
          <button className="arrow-btn" onClick={() => scroll(1)}>
            <img src={rightarrow} className="doc-nav-right" alt="right" />
          </button>
        }
      </div>
      {listData.length > 3 &&
        <div className="dots-container">
          {Array.from({ length: totalPages }).map((_, idx) => (
            <div
              key={idx}
              className={`dot ${currentPage === idx ? "active" : ""}`}
            ></div>
          ))}
        </div>
      }
    </div>
  );
};

export default CarouselView;


